<template>
  <div class="travel_option_detail">
    <template v-for="(leg, index) in travelLegs.legs">
      <travel-option-detail-way-point v-bind:leg="leg"  :key="leg.duration + 'd1'"></travel-option-detail-way-point>
      <travel-option-detail-connection v-bind:leg="leg" :key="leg.duration + 'd2'"></travel-option-detail-connection>
      <travel-option-detail-way-point 
      v-bind:leg="leg" 
      v-bind:last_waypoint="true"
      :key="leg.duration + 'd3'"
      v-if="index + 1 == travelLegs.legs.length"></travel-option-detail-way-point>
    </template>
    
  </div>
  

</template>

<script>
import Vuetify from 'vuetify';
import LegIcon from './LegIcon.vue'
import moment from 'moment';
import TravelOptionDetailWayPoint from './TravelOptionDetailWayPoint.vue';
import TravelOptionDetailConnection from './TravelOptionDetailConnection.vue';


export default {
  components: {
      LegIcon,
      TravelOptionDetailWayPoint,
      TravelOptionDetailConnection,
  },
  props: ['travelLegs'],
  data() {
    return {
      test: "",
    }
  },
  computed: {
    departureTime: function() {
      return moment(this.travel_data.startTime).format('HH:mm');
    },
    wayPoints: function() {
      var tmp = [];
      this.travelLegs.legs.forEach(
        leg => {
          tmp.push({expectedStartTime: leg.expectedStartTime})
        });
      console.log(this.travelLegs);
    },
  },
};

</script>


<style scoped>

.travel_option_detail::-webkit-scrollbar {
    width: 0.5em;
    height: 8px;
    background-color: whitesmoke;
}
.travel_option_detail::-webkit-scrollbar-track {
  background-color: whitesmoke;
  width: 1em;
  border-width: 0;
}
.travel_option_detail::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}

.travel_option_detail {
  display: inline-block;
  overflow-y: scroll;

  height: 100vh;
  width: 350px;
  background-color: whitesmoke;
  vertical-align: top;
  padding: 8px;
}


</style>